import { DefaultDataPoint, FontSpec, ChartDataset, ChartData } from 'chart.js';

import { ChartConfigBuilder, ChartDatasetConfigBuilder } from './chart-config.model';

export const baseChartConfig: ChartConfigBuilder<'line', DefaultDataPoint<'line'>> = (title?: string) => {
    return {
        type: 'line',
        data: {
            datasets: [],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 0,
            },

            plugins: {

                // deferred: {
                //     yOffset: '50%',
                // },

                title: {
                    display: false,
                    text: title,
                    fullSize: true,
                    font: () => <FontSpec>{ family : 'roboto'}
                },

                zoom: {
                    pan: {
                        enabled: true,
                        mode: 'xy',
                        modifierKey: 'ctrl',
                    },
                    zoom: {
                        mode: 'xy',
                        drag: {
                            enabled: true,
                            borderColor: 'rgb(54, 162, 235)',
                            borderWidth: 1,
                            backgroundColor: 'rgba(54, 162, 235, 0.3)'
                        }
                    }
                },

            },
            
            scales: {
                x: {
                    offset: false,
                    type: 'time',
                    time: {
                        displayFormats: {
                            'second': 'HH:mm:ss',
                            'minute': 'HH:mm',
                            'hour': 'HH:mm',
                            'day': 'll',
                            'week': 'lll',
                            'month': 'lll',
                            'quarter': 'lll',
                            'year': 'lll',
                         }
                    },
                
                    grid: {
                        display: true,
                    },
                    ticks: {
                        source: 'auto',
                        maxRotation: 0,
                        maxTicksLimit: 10,
                    },
                }
            },

        }
    };
}

export const baseDatasetConfig: ChartDatasetConfigBuilder = (datasets: ChartDataset[]) => {
    return <ChartData<'line', DefaultDataPoint<'line'>, unknown>> {
        datasets: datasets.map((dataset: ChartDataset) => ({
            ...dataset,
            spanGaps: false,
        })),
    };
}